import { PageHeader } from '@components/PageHeader'
import { PartialContainer } from '@components/layout'
import { NextSeo } from 'next-seo'
import { BlogCard } from './blogCard'
import { IBlogPost, tBlogPostCategories } from '@types'
import { TabPills } from '@components/navigation'
import { slugify } from '@utils'

export const BlogContainer = ({
  blogPosts,
  category,
}: {
  blogPosts: IBlogPost[]
  category?: tBlogPostCategories
}) => (
  <PartialContainer>
    <div className="mt-10">
      <NextSeo
        title={category || 'News & Updates'}
        description="Stay informed with the latest Market Insights, explore new Investment Opportunities, get updates on upcoming Events, and expand your knowledge with our Investing 101 articles - all in one place at MarketX Ventures News."
        canonical={`https://www.marketxventures.com/${
          category ? slugify(category) : 'news'
        }`}
        openGraph={{
          title: `News & Events | MarketX Ventures`,
          url: `https://www.marketxventures.com/${
            category ? slugify(category) : 'news'
          }`,
        }}
      />
      <PageHeader
        title={'News & Events from MarketX Ventures'}
        extra="Stay informed with the latest Market Insights, explore new Investment Opportunities, get updates on upcoming Events, and expand your knowledge with our Investing 101 articles - all in one place at MarketX Ventures News."
      />
      <div className="pb-5">
        <TabPills
          tabs={[
            { name: 'All', href: '/news', current: !category },
            {
              name: 'Opportunity News',
              href: '/opportunity-news',
              current: category == 'Opportunity News',
            },
            {
              name: 'Events',
              href: '/events',
              current: category == 'Events',
            },
            {
              name: 'Market Insights',
              href: '/market-insights',
              current: category == 'Market Insights',
            },
            {
              name: 'Investing 101',
              href: '/investing-101',
              current: category == 'Investing 101',
            },
          ]}
        />
      </div>
      <BlogCard blogPosts={blogPosts} />
    </div>
  </PartialContainer>
)
